module.exports = __webpack_public_path__ + "static/media/compose_private_message.e41b1582.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brite/compose_private_message.png
// module id = 286
// module chunks = 0